<template>
  <div class="board_wrap">
    <div class="board_title">
      <h1>MGN SYSTEM</h1>
    </div>
    <div class="aboutCorp">
      <div>
        마그넷 시스템 홈페이지를 방문해 주신 고객님께 진심으로 감사드립니다.
        <br />
        마그넷 시스템은
        <p>ERP ㆍ MES ㆍ POP ㆍ Mobile ㆍ Barcode System</p>
        업무용 시스템 솔루션 전문 회사입니다. 생산/제조, 물류/유통, 지입 기반으로 ERP 프로그램을 보유하고 있습니다. <br />
        고객의 안정적인 기업 운영관리를 위해 기업 내 업무 프로세스를 파악하여 적합한 솔루션을 제공하고 있습니다.<br />
        보유 프로그램 이외에 추가가 필요할 시 부가 시스템에 관해서 전문 담당자와 상담하여 구축해 드립니다. <br />
        끊임없는 변화와 혁신으로 고품격 솔루션 창출을 통해 고객만족의 극대화를 위해 노력하겠습니다.
        <br />
        <br />
        <div>
          <h1>보유 ERP 시스템 종류</h1>
          <p>상자 관리 시스템,&nbsp; 차량 관리 시스템, &nbsp;무역/물류 관리 시스템</p>
        </div>
      </div>
    </div>
    <div class="about_come">
      <h1>오시는 길</h1>
      <div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3165.686678875865!2d126.92292697999858!3d37.49171953626535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9f58a7f96cf7%3A0x82073af0d40bd424!2z7ISc7Jq47Yq567OE7IucIOuPmeyekeq1rCDsi6DrjIDrsKnrj5kg67O0652866ek66GcNeqwgOq4uCA3IOy6kOumre2EsOq3uOumsOu5jA!5e0!3m2!1sko!2skr!4v1665450394384!5m2!1sko!2skr"
          width="100%"
          height="450"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {},
}
</script>

<style scoped>
@import '../../style/content.css';

/* span {
  font-size: 22px;
  font-weight: 600;
} */
.board_title {
  text-align: center;
  padding-right: 80px;
  margin-bottom: 20px;
}

.board_title h1 {
  font-weight: 600;
  /* color: rgb(5, 56, 168); */
}
.aboutCorp {
  border-top: solid 2px;
  text-align: center;
}
.aboutCorp div {
  font-size: 18px;
  margin-bottom: 20px;
  padding: 10px;
}
.aboutCorp div h1 {
  font-size: 30px;
  color: rgb(5, 56, 168);
  font-weight: 700;
  margin-bottom: 10px;
}
.aboutCorp div p {
  font-size: 20px;
  font-weight: 600;
}
.about_come h1 {
  color: rgb(5, 56, 168);
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  padding-right: 100px;
  padding-bottom: 20px;
  margin: 0;
}
.about_come div {
  border-top: solid 2px;
  padding: 40px;
}
@media (max-width: 960px) {
  .board_title {
    padding-right: 30px;
  }
  .about_come h1 {
    padding: 0;
    /* padding-left: 30px; */
    padding-bottom: 20px;
    margin: 0;
  }
}
</style>
